import React, { useState } from "react";
import Container from "../../../components/Container/Container";
import Table from "../../../components/Table/Table";
import { API, ROUTER } from "../../../constants/env";
import { formatFirstName, formatLastName, formatProfilName } from "../../../utils/displayName";
import swal from "sweetalert";
import { Link } from "react-router-dom";

const ListCarnetPrepa = () => {
  const fields = [
    { title: "Prénom", field: "firstName" },
    { title: "Nom", field: "lastName" },
    { title: "Classe", field: "classe" },
    { title: "Triméstre", field: "trimestre" },
  ];
  const [data, setData] = useState([]);
  const fetchData = (
    currentPage,
    count,
    search,
    setTotalPage,
    setTotal,
    idClasse
  ) => {
    fetch(
      API.carnetPrepa.list +
        `?page=${currentPage}&count=${count}&searchQuery=${search}&filterByClasse=${idClasse}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }

        const result = response.data.map((elem) => ({
          _id: elem._id,
          firstName: formatFirstName(elem.student.profil.firstName),
          lastName: formatLastName(elem.student.profil.lastName),
          classe: elem.student.classe.name,
          trimestre: (
            <div>
              {" "}
              {elem.reportCards.map((card) => (
                <Link
                  as="button"
                  className="btn btn-light-primary btn-sm font-weight-bold mx-1"
                  to={`${ROUTER.CARNETPREPA.EDIT(card._id)}/${formatProfilName(
                    elem.student.profil
                  )}/${
                    card.semestre === "premier"
                      ? "1er Trimestre"
                      : card.semestre === "deuxieme"
                      ? "2eme Trimestre"
                      : "3eme Trimestre"
                  }`}
                >
                  {card.semestre === "premier"
                    ? "1er trim."
                    : card.semestre === "deuxieme"
                      ? "2ème trim."
                      : "3ème trim."}
                </Link>
              ))}
            </div>
          ),
        }));
        setData(result);
        setTotalPage(response.totalPage);
        setTotal(response.total);
      })
      .catch((e) => {
        swal("Error", e.message, "error");
      });
  };
  return (
    <Container name="Carnet Preparatoire">
      <Table
        pageName="CarnetPrepa"
        name="CarnetPrepa"
        classeApi={API.carnetPrepa.listPrepas}
        fields={fields}
        data={data}
        fetchData={fetchData}
        showSearch={true}
        hideActions={true}
        stopCheckbox={true}
      />
    </Container>
  );
};

export default ListCarnetPrepa;
